import styled from '@emotion/styled';
import Package from './Package';
import EnterpriseInfo from './Enterprise';
import { isMasterOnline, isSiteGiant } from 'productLine';

const Container = styled.div`
  margin: 16px;
  > * {
    margin-bottom: 16px;
  }
`;

function Enterprise() {
  return (
    <Container>
      {isMasterOnline || isSiteGiant ? null : <Package />}
      <EnterpriseInfo />
    </Container>
  );
}

export default Enterprise;
